import React from "react";
import { useCalculatorPageStyles } from "./index.styles";

export default function CalculatorPage() {
  const useStyles = useCalculatorPageStyles();

  return <div className={useStyles.container}>calculator</div>;
}
